module.exports = __webpack_public_path__ + "static/media/IconOrder.c56a57ed.svg";